module.exports = "<div class=\"card nav-container\">\n    <div class=\"ui-g-1 button\" (click)=\"goBack()\">\n        <i class=\"fa ui-icon-chevron-left\">\n        </i>\n    </div>\n    <div class=\"ui-g-11 title\">\n        <p>\n            {{ title }}\n        </p>\n    </div>\n    <div style=\"clear: both\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/fiscalia/component/forum/navigation-bar/navigation-bar.component.html
// module id = ./src/app/fiscalia/component/forum/navigation-bar/navigation-bar.component.html
// module chunks = main